import React, {
  useEffect,
  useRef,
  // useRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import {
  Avatar,
  Box,
  Button,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  // Paper,
  Select,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
//* Fecha formato
import NumFormat from "../../../helpers/numerico";
import bdService from "../../../services/maestros.service";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack"; //Para alertas notificaciones
import { DatePicker } from "@mui/x-date-pickers";
import { format } from "date-fns";
//****** iconos */
import styled from "@emotion/styled";
import CompareIcon from "@mui/icons-material/Compare";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import UndoIcon from "@mui/icons-material/Undo";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import FormatListNumberedRtlIcon from "@mui/icons-material/FormatListNumberedRtl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchIcon from "@mui/icons-material/Search";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import myIconNoEnviada from "../../../img/nosend.png";
import myIconNoImpresa from "../../../img/noprint.png";
import myIconNoPreparada from "../../../img/nopackage.png";

const CustomTextField13L = styled(TextField)({
  "& .MuiInputBase-input": {
    textAlign: "left",
    fontSize: "13px", // Ajusta el tamaño de fuente aquí
  },
});

//cantidad
// eslint-disable-next-line
const CustomTextFieldCnt = styled(TextField)({
  "& .MuiInputBase-input": {
    textAlign: "right",
    fontSize: "20px", // Ajusta el tamaño de fuente aquí
  },
});

// eslint-disable-next-line
const IPropslabel20px = {
  style: {
    color: "green",
    fontSize: "20px",
    textAlign: "right",
  },
};
// eslint-disable-next-line
const IPropslabel10px = {
  style: {
    color: "blue",
    fontSize: "10px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel11px = {
  style: {
    color: "blue",
    fontSize: "12px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel12px = {
  style: {
    color: "blue",
    fontSize: "12px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel13px = {
  style: {
    color: "blue",
    fontSize: "12px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel14px = {
  style: {
    color: "blue",
    fontSize: "12px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel15px = {
  style: {
    color: "blue",
    fontSize: "15px",
    textAlign: "center",
  },
};

// eslint-disable-next-line
const IPropsNumerico = {
  inputMode: "numeric",
  maxLength: 15,
};

// eslint-disable-next-line
const IPropsNumerico8 = {
  inputMode: "numeric",
  maxLength: 12,
};

const Producto = () => {
  const { enqueueSnackbar } = useSnackbar();

  //********** Sucursal ******************************/
  const [sucursales, setSucursales] = useState([]);
  const [bbloquearSucursal, setbbloquearSucursal] = useState(false);
  const [bSeleccionada, setbSeleccionada] = useState(false);
  // const [NomBodega, setNomBodega] = useState(null);
  const [NomBodega, setNomBodega] = useState("");
  // const [SucursalSeleccionada, setSucursalSeleccionada] = useState(null);
  const [SucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [BodegaSeleccionada, setBodegaSeleccionada] = useState("");
  //**************************************** */
  const [sSeleccionCod, setsSeleccionCod] = useState("I");
  const [bSeleccionDesRes, setbSeleccionDesRes] = useState(false);
  //**************************************** */
  //******* Codigo Obtenido  *****************/
  //**************************************** */
  const [bMostrarDato, setbMostrarDato] = useState(false);
  const [mostrarVentanaKardex, setMostrarVentanaKardex] = useState(false);
  const [MostrarKardex, setMostrarKardex] = useState(false);
  const [MostrarTab, setMostrarTab] = useState(false);
  const [KardexM, setKardexM] = useState([]);
  //**************************************** */
  //          Datos para mostrar
  //**************************************** */
  //const [ImagenFoto, setImagenFoto] = useState();
  const [ImagenFoto, setImagenFoto] = useState("");
  const [Codigo, setsCodigo] = useState("");
  const [CodigoBarra, setsCodigoBarra] = useState("");
  const [Nombre, setsNombre] = useState("");
  const [Unidad, setsUnidad] = useState("");
  const [Stock, setdStock] = useState(0);
  const [Origen, setsOrigen] = useState("");
  // const [Familia, setsFamilia] = useState("");
  // const [SubFamilia, setsSubFamilia] = useState("");
  const [Peso, setPeso] = useState(0);
  const [Volumen, setVolumen] = useState(0);
  const [Largo, setLargo] = useState(0);
  const [Alto, setAlto] = useState(0);
  const [Ancho, setAncho] = useState(0);
  //**************************************** */
  // Dialog
  //**************************************** */
  const [selectedDateDesde, setSelectedDateDesde] = useState(null);
  const [selectedDateHasta, setSelectedDateHasta] = useState(null);
  const [valueRadio, setValueRadio] = React.useState("I");
  //**************************************** */
  // Redux
  //**************************************** */
  const { usuario } = useSelector((state) => state.user);
  //*************************************** */
  // Barra de progreso
  //*************************************** */
  const [loading, setLoading] = useState(false);
  //*************************************** */
  const ScanBarraRef = useRef(null);
  const ScanProductoRef = useRef(null);
  const tableEndRef = useRef(null);
  const tableStartRef = useRef(null);
  // ********************************************************** */
  // ****************** Llenado Sucursal ********************** */
  // ********************************************************** */
  const Limpiar = () => {
    //********** Sucursal ******************************/
    setbSeleccionada(false);
    setNomBodega("");
    setSucursalSeleccionada(null);
    setBodegaSeleccionada("");
    setbSeleccionDesRes(false);
    setbMostrarDato(false);
    setbbloquearSucursal(false);
    setMostrarTab(false);
    setValue("producto");
    /****** Producto  */
    LimpiarProducto();
  };

  // Función para desplazarse al final de la tabla
  const scrollToTableEnd = () => {
    tableEndRef.current.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToTableTop = () => {
    tableStartRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const LimpiarProducto = () => {
    /****** Producto  */
    setbMostrarDato(false);
    setMostrarTab(false);
    setImagenFoto(null);
    setsCodigo("");
    setsCodigoBarra("");
    setsNombre("");
    setsUnidad("");
    setdStock(0);
    setsOrigen("");
    // setsCategoria("");
    // setsFamilia("");
    // setsSubFamilia("");
    setPeso(0);
    setVolumen(0);
    setLargo(0);
    setAlto(0);
    setAncho(0);
  };

  const CargarBodegas = async () => {
    try {
      const iSucursal =
        parseInt(usuario.TipoUsuario) <= 5 ? -1 : usuario.Sucursal;
      const datos = await bdService.Bodegas(iSucursal, "A");
      if (datos.status === 200) {
        // Llenado
        setSucursales(datos.data.Sucursales);
        if (parseInt(usuario.TipoUsuario) <= 1) {
          //******** Seleccionar una sucursal */
          setbSeleccionada(false);
          setbbloquearSucursal(false);
        } else {
          if (datos.data.Sucursales.length === 1) {
            //******** Asignando datos de la bodega automaticamente */
            setNomBodega(datos.data.Sucursales[0].Nombre);
            setSucursalSeleccionada(datos.data.Sucursales[0].Sucursal);
            setBodegaSeleccionada(datos.data.Sucursales[0].Bodega);
            setbSeleccionada(true);
            setbSeleccionDesRes(true);
            setbbloquearSucursal(true);
          } else {
            //******** Seleccionar una sucursal */
            setbSeleccionada(false);
            setbbloquearSucursal(false);
          }
        }
      } else if (datos.status === 400) {
        // Esta mal
      }
    } catch (error) {
      // Manejo del error si ocurre
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    Limpiar();
    CargarBodegas();
  }, []);

  //********************* Combo sucursal */
  const handleChangeComboBox = async (event) => {
    const nombreSeleccionado = event.target.value;
    const SucBodSelect = sucursales.find(
      (sucursal) => sucursal.Nombre === nombreSeleccionado
    );
    setSucursalSeleccionada(SucBodSelect.Sucursal);
    setBodegaSeleccionada(SucBodSelect.Bodega);
    setNomBodega(nombreSeleccionado);
    setbSeleccionada(true); //cambia a seleccionada a true para continuar
    setbSeleccionDesRes(true); // Para que aparezca los botones de Despacho y Reserva
  };

  //*********************************************************** */
  //**************** Consultando al CodigoBarra */
  //*********************************************************** */
  const handleKeyDownCodBarra = async (event) => {
    if (event.key === "Enter") {
      var CodigoBarra_value = event.target.value;
      var _CodigoBarra;
      if (CodigoBarra_value === null) {
        _CodigoBarra = "*";
      } else {
        _CodigoBarra = CodigoBarra_value.padStart(15, "*");
      }
      try {
        const response = await bdService.Producto(
          SucursalSeleccionada,
          BodegaSeleccionada,
          "-1",
          _CodigoBarra
        );

        if (response.status === 200) {
          ExtraccionDatos(response.data.productos[0]);
        } else {
          LimpiarProducto();
          enqueueSnackbar(`Error en extración de datos ${response.data.msg}`, {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        }
        /******************* */
        event.target.value = "";
        setTimeout(() => {
          ScanBarraRef.current.focus();
        }, 500);
        /******************* */
      } catch (error) {
        LimpiarProducto();
        enqueueSnackbar(`Error try ${error}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        console.error(error);
      }
    }
  };

  const handleKeyDownCodProducto = async (event) => {
    if (event.key === "Enter") {
      var CodigoProd_value = event.target.value;
      var _CodigoProducto;
      if (CodigoProd_value === null) {
        _CodigoProducto = "-1";
      } else {
        _CodigoProducto = CodigoProd_value.replace(/-/g, "");
      }
      try {
        const response = await bdService.Producto(
          SucursalSeleccionada,
          BodegaSeleccionada,
          _CodigoProducto,
          "-1"
        );
        if (response.status === 200) {
          ExtraccionDatos(response.data.productos[0]);
        } else {
          LimpiarProducto();
          enqueueSnackbar(`Error en base de datos: ${response.data.msg}`, {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        }
        /******************* */
        event.target.value = "";
        setTimeout(() => {
          ScanProductoRef.current.focus();
        }, 500);
        /******************* */
      } catch (error) {
        LimpiarProducto();
        enqueueSnackbar(`Error try ${error}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        console.error(error);
      }
    }
  };
  //Colocando datos de entrada .
  const handleKardexFin = async () => {
    setMostrarVentanaKardex(false);
    //Buscar kardex con fecha colocada.
    //************* Variables obtenidas en dialog */
    const fechadesde = format(new Date(selectedDateDesde), "ddMMyyyy");
    const fechahasta = format(new Date(selectedDateHasta), "ddMMyyyy");
    const sCodigo = Codigo.replace(/-/g, "");
    const sDocumento = valueRadio;
    setLoading(true);
    await BuscarKardex(fechadesde, fechahasta, sCodigo, sDocumento);
    setLoading(false);
  };

  //Automatico
  const handleChange = async (event, newValue) => {
    // event.type can be equal to focus with selectionFollowsFocus.
    if (event.type !== "click" || event.type === "click") {
      if (newValue === 1) {
        //************* Automatico */
        const fechaActual = new Date();
        const fechahasta = format(new Date(fechaActual), "ddMMyyyy");
        fechaActual.setMonth(fechaActual.getMonth() - 2);
        let fechadesde = format(new Date(fechaActual), "ddMMyyyy");
        let sCodigo = Codigo.replace(/-/g, "");
        //*fechadesde = "01012020";
        setLoading(true);
        await BuscarKardex(fechadesde, fechahasta, sCodigo, "I");
        setLoading(false);
      }
      setValue(newValue);
    }
  };

  const BuscarKardex = async (sFechaDesde, sFechaHasta, sCodaBuscar, sDoc) => {
    try {
      /**************************** Variables */
      let fechadesde = sFechaDesde;
      let fechahasta = sFechaHasta;
      let sDocumento = sDoc;
      let sCodigo = sCodaBuscar.replace(/-/g, "");
      /********************************* */
      const response = await bdService.Kardex(
        SucursalSeleccionada,
        BodegaSeleccionada,
        sCodigo,
        fechadesde,
        fechahasta,
        usuario.TipoUsuario,
        sDocumento
      );
      if (response.status === 200) {
        setMostrarKardex(true);
        setKardexM(response.data.kardex);
      } else {
        enqueueSnackbar(`Error en base de datos: ${response.data.msg}`, {
          variant: "warning",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    } catch (error) {
      LimpiarProducto();
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      // console.error(error);
    }
  };
  const ExtraccionDatos = (datos) => {
    setValue(0);
    setMostrarTab(true);
    setbMostrarDato(true);
    setsCodigo(datos.CodigoFormato);
    setsCodigoBarra(datos.CodigoBarra);
    setsNombre(datos.Nombre);
    setsUnidad(datos.Unidad);
    setdStock(datos.Stock);

    setsOrigen(datos.Origen === "I" ? "Internacional" : "Nacional");
    // setsCategoria(datos.NombreCategoria);
    // setsFamilia(datos.NombreFamilia);
    // setsSubFamilia(datos.NombreSubFamilia);
    setPeso(datos.Kilo);
    setVolumen(datos.Volumen);
    setLargo(datos.Largo);
    setAlto(datos.Alto);
    setAncho(datos.Ancho);
    if (datos.ImagenFoto !== null) {
      var base64Flag = "data:image/jpeg;base64,";
      var imageStr = arrayBufferToBase64(datos.ImagenFoto.data);
      var ValorImagen = base64Flag + imageStr;
      setImagenFoto(ValorImagen);
    } else {
      setImagenFoto(null);
    }
  };

  const arrayBufferToBase64 = (buffer) => {
    var binary = "";
    var bytes = [].slice.call(new Uint8Array(buffer));
    bytes.forEach((b) => (binary += String.fromCharCode(b)));
    return window.btoa(binary);
  };

  const onClickCodBarra = () => {
    setsSeleccionCod("B");
    setbSeleccionDesRes(false);
    setTimeout(() => {
      ScanBarraRef.current.focus();
    }, 200);
  };

  const onClickCodProducto = () => {
    setsSeleccionCod("P");
    setbSeleccionDesRes(false);
    setTimeout(() => {
      ScanProductoRef.current.focus();
    }, 200);
  };

  const onClickVolver = () => {
    setsSeleccionCod("I");
    setbSeleccionDesRes(true);
    LimpiarProducto();
  };

  const handleCloseKardex = () => {
    setMostrarVentanaKardex(false);
  };

  const handleClickOpenKardex = () => {
    setMostrarVentanaKardex(true);
    setMostrarKardex(true);
    const fechaActual = new Date();
    const anioActual = fechaActual.getFullYear();
    const actualFechaStr = `${anioActual}/01/01`;
    // const fechaFormateada = format(new Date(actualFechaStr), "ddMMyyyy");
    const fechaHastaStr = `${anioActual}/12/31`;
    const ActualFecha = new Date(actualFechaStr);
    const FechaHasta = new Date(fechaHastaStr);
    // Asignar las fechas a las variables de estado (si esas variables están definidas en tu componente)
    setSelectedDateDesde(ActualFecha);
    setSelectedDateHasta(FechaHasta);
  };

  const handleCancelarKardex = () => {
    setMostrarVentanaKardex(false);
  };
  const handleDateChangeDesde = (date) => {
    setSelectedDateDesde(date);
  };

  const handleDateChangeHasta = (date) => {
    setSelectedDateHasta(date);
  };

  const handleChangeRadio = (event) => {
    setValueRadio(event.target.value);
  };

  const [value, setValue] = React.useState(0);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 0 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    let bEntrada = row.Entrada > 0 ? true : false;
    let fechaFormateada = format(new Date(row.Fecha), "dd-MM-yyyy");
    const existencia = row.Existencia;
    const valor = row.Entrada > 0 ? row.Entrada : row.Salida;
    const doc = row.Numero > 0 ? row.TipoDetalle + " " + row.Numero : "";
    // Función para obtener el ícono basado en el estado
    const getIconForEstado = (estado) => {
      switch (estado) {
        case "No Enviada":
          return myIconNoEnviada;
        case "No Impresa":
          return myIconNoImpresa;
        case "No Preparada":
          return myIconNoPreparada;
        default:
          return null; // Si no hay un ícono para el estado
      }
    };
    // // Obtener el ícono correspondiente
    const iconSrc = getIconForEstado(row.EstadoDetalle);

    return (
      <>
        {row.Numero > 0 ? (
          <TableRow>
            <TableCell colSpan={4}>
              <span
                style={{
                  fontSize: "14px",
                  color: bEntrada ? "green" : "red",
                  marginRight: "10px",
                }}
              >
                {fechaFormateada}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  color: bEntrada ? "blue" : "blue",
                }}
              >
                {doc}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  color: bEntrada ? "blue" : "blue",
                }}
              ></span>
              {/* Ícono basado en el estado */}
              {iconSrc && (
                <span>
                  <img
                    src={iconSrc}
                    alt={row.EstadoDetalle}
                    style={{ width: "32px", height: "32px", marginLeft: "8px" }}
                  />
                </span>
              )}
            </TableCell>
          </TableRow>
        ) : (
          <TableRow>
            <TableCell colSpan={2}>
              <span
                style={{ fontSize: "14px", color: bEntrada ? "green" : "red" }}
              >
                Inventario / Inicialización
              </span>
            </TableCell>
          </TableRow>
        )}
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          {row.Numero > 0 ? (
            <TableCell>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </TableCell>
          ) : (
            <TableCell></TableCell>
          )}
          <TableCell align="right">
            {row.Numero > 0 ? (
              <span
                style={{ fontSize: "14px", color: bEntrada ? "green" : "red" }}
              >
                {row.Numero > 0 ? (bEntrada ? "+" : "-") : null}
                {NumFormat.NumeroFormateado(valor.toString(), false, true, 2)}
              </span>
            ) : null}
          </TableCell>
          <TableCell align="right">
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>
              {NumFormat.NumeroFormateado(
                existencia.toString(),
                false,
                true,
                2
              )}
            </span>
          </TableCell>
        </TableRow>
        {row.Numero > 0 ? (
          <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Typography variant="body1" gutterBottom component="div">
                    Detalle
                  </Typography>
                  <Table size="small" aria-label="kardex">
                    <TableHead>
                      <TableRow>
                        <TableCell align="right">
                          <span style={{ fontSize: "8px" }}>Documento</span>
                        </TableCell>
                        <TableCell align="right">
                          <span style={{ fontSize: "8px" }}>Numero</span>
                        </TableCell>
                        <TableCell align="right">
                          <span style={{ fontSize: "8px" }}>Proveedor</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow key={{ doc }}>
                        <TableCell component="th" scope="row">
                          <span style={{ fontSize: "8px" }}>{doc}</span>
                        </TableCell>
                        <TableCell align="right">
                          <span style={{ fontSize: "8px" }}>{row.Numero}</span>
                        </TableCell>
                        <TableCell align="right">
                          <span style={{ fontSize: "8px" }}>
                            {row.RazonSocial}
                          </span>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        ) : null}
      </>
    );
  }

  //*********************************************************** */
  return (
    <div>
      <Container maxWidth="sm">
        <Container maxWidth="sm" sx={{ mt: 1 }}></Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Box
              borderRadius="8px"
              sx={{ boxShadow: 1, backgroundColor: "#FFFFFF", height: "auto" }}
            >
              <Grid container spacing={1} sx={{ p: 1 }}>
                <Grid item xs={12} sm={12}>
                  <Box sx={{ color: "text.secondary", textAlign: "center" }}>
                    Productos
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Select
                    value={NomBodega} // we want to work in controlled mode
                    displayEmpty
                    fullWidth
                    onChange={handleChangeComboBox} // we want to work in controlled mode
                    disabled={bbloquearSucursal}
                  >
                    <MenuItem value="" disabled>
                      Sucursales
                    </MenuItem>
                    {sucursales?.map((option) => {
                      return (
                        <MenuItem key={option.Nombre} value={option.Nombre}>
                          {option.Nombre ?? option.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        {bSeleccionada && bSeleccionDesRes && sSeleccionCod === "I" && (
          <Box
            borderRadius="8px"
            sx={{
              boxShadow: 1,
              backgroundColor: "#FFFFFF",
              height: "auto",
              p: 3,
              display: "flex",
              justifyContent: "center", // Centra los elementos horizontalmente
              alignItems: "center", // Centra los elementos verticalmente
            }}
          >
            <Grid container spacing={1} sx={{ p: 3 }}>
              <Grid item xs={12}>
                <Stack spacing={2} direction="column">
                  <Button
                    variant="contained"
                    startIcon={<DocumentScannerIcon />}
                    onClick={onClickCodBarra}
                  >
                    Código de Barra
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<CompareIcon />}
                    onClick={onClickCodProducto}
                  >
                    Código de Producto
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        )}
        {sSeleccionCod === "B" ? (
          <>
            <Grid container sx={{ p: 1 }} spacing={1}>
              <Grid item xs={2}>
                <IconButton onClick={onClickVolver}>
                  <Avatar sx={{ backgroundColor: "green" }}>
                    <UndoIcon />
                  </Avatar>
                </IconButton>
              </Grid>
              <Grid item xs={10}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CustomTextField13L
                    fullWidth
                    inputRef={ScanBarraRef}
                    label="Scan Cód.Barra"
                    color="success"
                    onKeyDown={handleKeyDownCodBarra}
                    inputProps={IPropsNumerico}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        ) : sSeleccionCod === "P" ? (
          <>
            <Grid container sx={{ p: 1 }} spacing={6}>
              <Grid item xs={2}>
                <IconButton onClick={onClickVolver}>
                  <Avatar sx={{ backgroundColor: "green" }}>
                    <UndoIcon />
                  </Avatar>
                </IconButton>
              </Grid>
              <Grid item xs={10}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CustomTextField13L
                    fullWidth
                    inputRef={ScanProductoRef}
                    label="Escribir Cód.Producto"
                    color="success"
                    onKeyDown={handleKeyDownCodProducto}
                    inputProps={IPropsNumerico8}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        ) : null}
        {MostrarTab && (
          <Box
            sx={{
              flexGrow: 1,
              bgcolor: "background.paper",
              display: "grid",
              height: 50,
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab
                icon={<WysiwygIcon />}
                aria-label="producto"
                value={0}
                {...a11yProps(0)}
              />
              <Tab
                icon={<FormatListNumberedRtlIcon />}
                aria-label="kardex"
                value={1}
                {...a11yProps(1)}
              />
            </Tabs>
            <TabPanel value={value} index={0}>
              {bMostrarDato && (
                <Grid container sx={{ p: 1 }} spacing={1}>
                  <Grid item xs={12}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        textAlign: "center",
                        maxWidth: "100%",
                      }}
                    >
                      {ImagenFoto ? (
                        <>
                          <Typography variant="body1" fontWeight="bold">
                            Imagen
                          </Typography>
                          <img
                            style={{
                              maxWidth: "100%",
                              height: "auto",
                              padding: "0",
                              margin: "0",
                            }}
                            src={ImagenFoto}
                            alt="Imagen"
                          />
                        </>
                      ) : (
                        <Typography variant="body1" fontWeight="bold">
                          La imagen no está disponible.
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Código
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">{Codigo}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Código Barra
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {CodigoBarra ? CodigoBarra : "*********"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Nombre
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">{Nombre}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Unidad
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">{Unidad}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Stock
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "yellow",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        {NumFormat.NumeroFormateado(
                          Stock.toString(),
                          false,
                          true,
                          2
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Origen
                      </Typography>
                    </Box>
                  </Grid>{" "}
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "green",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        color={"white"}
                      >
                        {Origen}
                      </Typography>
                    </Box>
                  </Grid>
                  {/* <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Familia
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">{Familia}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        SubFamilia
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">{SubFamilia}</Typography>
                    </Box>
                  </Grid>{" "} */}
                  <Grid item xs={12}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Medidas
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Peso
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {NumFormat.NumeroFormateado(
                          Peso.toString(),
                          false,
                          true,
                          2
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Volumen
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {NumFormat.NumeroFormateado(
                          Volumen.toString(),
                          false,
                          true,
                          4
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Largo
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {NumFormat.NumeroFormateado(
                          Largo.toString(),
                          false,
                          false
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Alto
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {" "}
                        {NumFormat.NumeroFormateado(
                          Alto.toString(),
                          false,
                          false
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Ancho
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      borderRadius={"8px"}
                      sx={{
                        boxShadow: 1,
                        backgroundColor: "#FFFFFF",
                        color: "text.secondary",
                        p: 1,
                        maxWidth: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1">
                        {NumFormat.NumeroFormateado(
                          Ancho.toString(),
                          false,
                          false
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </TabPanel>
            <TabPanel value={value} index={1}>
              {MostrarKardex && (
                <>
                  <Box
                    borderRadius="8px"
                    sx={{
                      // boxShadow: 1,
                      // backgroundColor: "#FFFFFF",
                      height: "auto",
                      p: 1,
                      m: 1,
                      display: "flex",
                      justifyContent: "center", // Centra los elementos horizontalmente
                      alignItems: "center", // Centra los elementos verticalmente
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={6} container justifyContent="left">
                        <Box
                          borderRadius="8px"
                          boxShadow={1}
                          bgcolor="#FFFFFF"
                          color="text.secondary"
                          p={1}
                        >
                          <Button
                            onClick={handleClickOpenKardex}
                            variant="outlined"
                          >
                            <SearchIcon /> Busqueda
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={6} container justifyContent="right">
                        <Box
                          borderRadius="8px"
                          boxShadow={1}
                          bgcolor="#FFFFFF"
                          color="text.secondary"
                          p={1}
                        >
                          <Button variant="outlined" onClick={scrollToTableEnd}>
                            <ArrowCircleDownIcon />
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Grid
                    spacing={0}
                    alignItems="center"
                    justifyContent="center"
                    item
                    sx={{ p: 0 }}
                    xs={12}
                  >
                    {mostrarVentanaKardex && (
                      <Dialog
                        open={mostrarVentanaKardex}
                        onClose={handleCloseKardex}
                        maxWidth="xs sm md lg"
                      >
                        <DialogTitle>Kardex</DialogTitle>
                        <DialogActions>
                          <FormControl>
                            <Box sx={{ color: "text.secondary", p: 2 }}>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                sx={{ p: 1 }}
                              >
                                <DatePicker
                                  label="Fecha Desde"
                                  value={selectedDateDesde}
                                  onChange={handleDateChangeDesde}
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                sx={{ p: 1 }}
                              >
                                <DatePicker
                                  label="Fecha Hasta"
                                  value={selectedDateHasta}
                                  onChange={handleDateChangeHasta}
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <RadioGroup
                                  aria-labelledby="demo-controlled-radio-buttons-group"
                                  name="controlled-radio-buttons-group"
                                  value={valueRadio}
                                  onChange={handleChangeRadio}
                                >
                                  <FormControlLabel
                                    value="I"
                                    control={<Radio />}
                                    label="Fecha Ingreso"
                                  />
                                  <FormControlLabel
                                    value="D"
                                    control={<Radio />}
                                    label="Fecha Documento"
                                  />
                                </RadioGroup>
                              </Grid>
                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6} sm={6} md={6} lg={6}>
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={handleKardexFin}
                                  sx={{ width: "100%", mr: 1 }}
                                >
                                  Aceptar
                                </Button>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={6}>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={handleCancelarKardex}
                                  sx={{ width: "100%", mr: 1 }}
                                >
                                  Cancelar
                                </Button>
                              </Grid>
                            </Grid>
                          </FormControl>
                        </DialogActions>
                      </Dialog>
                    )}
                    {loading ? (
                      <Box sx={{ width: "100%" }}>
                        <LinearProgress />
                      </Box>
                    ) : (
                      <>
                        <div ref={tableStartRef}></div>
                        <TableContainer component={Paper}>
                          <Table stickyHeader aria-label="collapsible table">
                            <TableHead>
                              <TableRow>
                                <TableCell />
                                <TableCell align="left">
                                  <span style={{ fontSize: "10px" }}>
                                    Ent/Sal
                                  </span>
                                </TableCell>
                                <TableCell align="left">
                                  <span style={{ fontSize: "10px" }}>
                                    Existencia
                                  </span>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {KardexM.map((row) => (
                                <Row key={row.Item} row={row} />
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {/* Referencia al final de la tabla */}
                        <div ref={tableEndRef}></div>
                        <Grid container spacing={1}>
                          <Grid
                            item
                            xs={12}
                            container
                            justifyContent="right"
                            sx={{ m: 1 }}
                          >
                            <Box
                              borderRadius="8px"
                              boxShadow={1}
                              bgcolor="#FFFFFF"
                              color="text.secondary"
                              p={1}
                            >
                              <Button
                                variant="outlined"
                                onClick={scrollToTableTop}
                              >
                                <ArrowCircleUpIcon />
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </>
              )}
            </TabPanel>
          </Box>
        )}
      </Container>
    </div>
  );
};
export default Producto;
